module.exports = __webpack_public_path__ + "img/tabbed-search-filter-cjdr.a498a51e.png";